import { useEffect, useRef, useState } from "react";
import { SORT_CALCUL_MODIFIED_AT_DESC } from "../../../common/constants/sort";
import useScrollOnDrag from "react-scroll-ondrag";
import FolderCalculRow from "./FolderCalculRow";
import { useParams } from "react-router-dom";
import { MFCheckbox } from "../../../common/components/MFCheckbox";
import { CalculTableHeaders } from "../../calcul/components/utils/CalculTableHeaders";
import {
  DOWNLOADXLS,
  DOWNLOADXMLCONFIG,
  DOWNLOADXMLINIES,
} from "../../fdes/constants/metadata";
import { FINISHED } from "../../calcul/constants";

const FolderCalculsTable = ({
  user,
  duplicateCalcul,
  folderCalculs,
  changeFolderCalculsSort,
  isGeneratingReports,
  generatingReportsIds,
  folderCalculsSort,
  generateReports,
  aggregatedFamilyProducts,
  getFdesMetadataCalculRow,
  sendXmlToEDEC,
  localEDECIntegration,
  folders,
  createFolder,
  tableScrollDisabled,
  loadFolderCalculs,
  manageCalculsFolders,
  setCalculArchived,
  deleteCalcul,
  restoreArchivedCalcul,
  updateCalculAttributes,
  calculsColumns,
  setSelectedCalculs,
  selectedCalculs,
  clearFolderInfos,
}) => {
  const [folderId, setFolderId] = useState("");
  const isArchivesFolder = folderId === "archives";
  const selectedCalculsOnThisPage = folderCalculs
    .filter((calcul) => selectedCalculs.map((c) => c.id).includes(calcul._id))
    .map((calcul) => calcul._id);

  const params = useParams();
  const ref = useRef();
  const { events } = useScrollOnDrag(ref, {});

  useEffect(() => {
    if (params && params.folderId) {
      setFolderId(params.folderId);
    }
    return () => {
      clearFolderInfos();
    };
  }, [params]); // eslint-disable-line

  function handleSort(sortAsc, sortDesc) {
    if (folderCalculsSort === sortAsc) {
      changeFolderCalculsSort(sortDesc, folderId);
    } else if (
      folderCalculsSort === sortDesc &&
      folderCalculsSort !== SORT_CALCUL_MODIFIED_AT_DESC
    ) {
      changeFolderCalculsSort(SORT_CALCUL_MODIFIED_AT_DESC, folderId);
    } else {
      changeFolderCalculsSort(sortAsc, folderId);
    }
  }

  function handleSelectAll() {
    if (selectedCalculsOnThisPage.length === folderCalculs.length) {
      setSelectedCalculs(
        selectedCalculs.filter(
          (c) => !selectedCalculsOnThisPage.includes(c.id),
        ),
      );
    } else {
      setSelectedCalculs([
        ...selectedCalculs.filter(
          (c) => !folderCalculs.some((calcul) => calcul._id === c.id),
        ),
        ...folderCalculs.map((calcul) => {
          const downloadXml =
            calcul.fdesMetadata.find((e) => e.paramId === DOWNLOADXMLCONFIG)
              ?.visible ?? false;
          const downloadXmlInies =
            calcul.fdesMetadata.find((e) => e.paramId === DOWNLOADXMLINIES)
              ?.visible ?? false;
          const downloadXls =
            calcul.fdesMetadata.find((e) => e.paramId === DOWNLOADXLS)
              ?.visible ?? false;

          return {
            id: calcul._id,
            name: calcul.title,
            isDuplicable: isArchivesFolder ? false : !!calcul.isCompatible,
            isFinished: calcul.status === FINISHED,
            isRestorable: !!isArchivesFolder,
            simulationMode: calcul?.options?.simulationMode === true,
            folderIds: calcul.folders?.map((f) => f._id) || [],
            outputs: [
              "pdf",
              ...(downloadXml ? ["xml"] : []),
              ...(downloadXmlInies ? ["inies"] : []),
              ...(downloadXls ? ["xls"] : []),
            ],
          };
        }),
      ]);
    }
  }

  return (
    <div
      ref={ref}
      onMouseDown={tableScrollDisabled ? undefined : events.onMouseDown}
      className="d-block tableFixHead"
      style={{
        userSelect: "none",
      }}
    >
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="selection-column">
              <MFCheckbox
                checked={
                  selectedCalculsOnThisPage.length > 0 &&
                  selectedCalculsOnThisPage.length === folderCalculs.length
                }
                onChange={handleSelectAll}
              />
            </th>
            <CalculTableHeaders
              calculsColumns={calculsColumns}
              handleSort={handleSort}
              sort={folderCalculsSort}
              isArchivesFolder={isArchivesFolder}
            />
            {selectedCalculs.length === 0 && (
              <th className="px-1 actions-column">Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {folderCalculs &&
            folderCalculs.length > 0 &&
            folderCalculs.map((calcul, index) => (
              <FolderCalculRow
                key={calcul._id}
                user={user}
                isGeneratingReports={isGeneratingReports}
                generatingReportsIds={generatingReportsIds}
                duplicateCalcul={duplicateCalcul}
                calcul={calcul}
                generateReports={generateReports}
                aggregatedFamilyProducts={aggregatedFamilyProducts}
                getFdesMetadataCalculRow={getFdesMetadataCalculRow}
                sendXmlToEDEC={sendXmlToEDEC}
                localEDECIntegration={localEDECIntegration}
                folders={folders}
                createFolder={createFolder}
                index={index}
                folderId={folderId}
                loadFolderCalculs={loadFolderCalculs}
                manageCalculsFolders={manageCalculsFolders}
                isArchivesFolder={isArchivesFolder}
                setCalculArchived={setCalculArchived}
                deleteCalcul={deleteCalcul}
                restoreArchivedCalcul={restoreArchivedCalcul}
                updateCalculAttributes={updateCalculAttributes}
                calculsColumns={calculsColumns}
                selectedCalculs={selectedCalculs}
                setSelectedCalculs={setSelectedCalculs}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default FolderCalculsTable;
